import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { asyncValidate } from '../../utils/validation';
import { addProduct, archiveProduct, stateOnlySaveProduct, stateOnlyArchiveProduct } from 'redux/modules/products';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import DatePicker from 'material-ui/DatePicker';
import { ProductAccordion } from 'containers';
import { GrayButton, SecondaryButton, Spinner, Tooltip } from 'components';
import styles from './NewPartnerForm.scss';
import { Field, formValues, reduxForm } from 'redux-form';
var NewPartnerForm = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    products: state.products.agreementProducts,
    theme: state.theme
  };
}, {
  addProduct: addProduct,
  archiveProduct: archiveProduct,
  stateOnlySaveProduct: stateOnlySaveProduct,
  stateOnlyArchiveProduct: stateOnlyArchiveProduct,
  asyncValidate: asyncValidate
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewPartnerForm, _Component);

  var _super = _createSuper(NewPartnerForm);

  function NewPartnerForm() {
    var _this;

    _classCallCheck(this, NewPartnerForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "defaultProps", {
      isMultilocationContract: false,
      isAffiliateContract: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var val = e.target.value;
      var fieldName = e.target.id;

      _this.props.handleFormFieldChange(fieldName, val);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateChange", function (e, date) {
      _this.props.handleFormFieldChange('contractStartsAt', date);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectChange", function (e, index, value) {
      _this.props.handleFormFieldChange('contractMonths', value);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePaymentSelectChanged", function (e, index, value) {
      _this.props.handleFormFieldChange('paymentDetailEntryType', value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (fieldName, value, hintText, floatingLabelText, width) {
      floatingLabelText = typeof floatingLabelText === 'undefined' ? hintText : floatingLabelText;
      width = typeof width === 'undefined' ? '100%' : width;
      return /*#__PURE__*/React.createElement(TextField, {
        hintText: hintText,
        floatingLabelText: floatingLabelText,
        id: fieldName,
        value: value,
        onChange: _this.handleChange,
        style: {
          width: width
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderAsyncEmailField", function (_ref) {
      var input = _ref.input,
          _ref$meta = _ref.meta,
          asyncValidating = _ref$meta.asyncValidating,
          touched = _ref$meta.touched,
          error = _ref$meta.error;
      return /*#__PURE__*/React.createElement("div", {
        className: asyncValidating ? 'async-validating' : ''
      }, /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
        hintText: 'Email',
        style: {
          width: '100%'
        },
        errorText: touched && error,
        helperText: touched && error,
        value: _this.props.formValues.email,
        id: 'email',
        floatingLabelText: 'Email'
      })));
    });

    return _this;
  }

  _createClass(NewPartnerForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          formValues = _this$props.formValues,
          isAffiliateContract = _this$props.isAffiliateContract,
          isMultilocationContract = _this$props.isMultilocationContract;
      return /*#__PURE__*/React.createElement("div", {
        style: this.props.style,
        id: "NewPartnerForm"
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Customer Details"), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginBottom: 40
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.renderInput('firstName', formValues.firstName, 'First Name')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, this.renderInput('lastName', formValues.lastName, 'Last Name')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "email",
        floatingLabelText: 'Email',
        component: this.renderAsyncEmailField,
        id: 'email',
        onChange: this.handleChange,
        value: formValues.email
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(TextField, {
        hintText: 'Business Name',
        floatingLabelText: 'Business Name',
        id: 'businessName',
        value: formValues.businessName,
        onChange: function onChange(e, val) {
          if (formValues.businessSubdomainLink === 1) {
            var sub = "".concat(val).toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

            _this2.props.handleFormFieldChange('whitelabelSubdomain', sub, 'businessName', val);
          } else {
            _this2.props.handleFormFieldChange('businessName', val);
          }
        },
        style: {
          width: '33%'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'baseline'
        }
      }, /*#__PURE__*/React.createElement(TextField, {
        hintText: 'Partner Domain',
        floatingLabelText: 'Partner Domain',
        id: 'whitelabelSubdomain',
        value: formValues.whitelabelSubdomain,
        onChange: function onChange(e, rawVal) {
          var _this2$props;

          var val = "".concat(rawVal).toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
          var args = ['whitelabelSubdomain', val];

          if (formValues.businessSubdomainLink === 1) {
            args.push('businessSubdomainLink', 0);
          } else if (formValues.businessName.length === 0 && val.length === 0) {
            args.push('businessSubdomainLink', 1);
          }

          (_this2$props = _this2.props).handleFormFieldChange.apply(_this2$props, args);
        },
        style: {
          width: '33%'
        }
      }), /*#__PURE__*/React.createElement("span", null, ".cmsoc.com"))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('address1', formValues.address1, 'Address Line 1')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('address2', formValues.address2, 'Address Line 2')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, this.renderInput('locality', formValues.locality, 'City')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, this.renderInput('region', formValues.region, 'State')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, this.renderInput('postcode', formValues.postcode, 'Zip Code')), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderInput('phone', formValues.phone, 'Phone'))), /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, isAffiliateContract ? 'Agreement Details' : 'Product Details'), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 32
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-5",
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(SelectField, {
        floatingLabelText: "Payment Details",
        value: formValues.paymentDetailEntryType,
        onChange: this.handlePaymentSelectChanged
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1,
        primaryText: "Customer Entered"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 2,
        primaryText: "Likeable Local Entered"
      })), /*#__PURE__*/React.createElement(Tooltip, {
        message: /*#__PURE__*/React.createElement("span", null, "This determines whether the customer will be prompted to enter their", /*#__PURE__*/React.createElement("br", null), " payment information or whether Likeable Local will enter it for them."),
        style: {
          position: 'absolute',
          top: 0,
          color: '#555555'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-7",
        style: {
          textAlign: 'right'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'silver'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-3"
      }, "$", this.renderInput('monthlyFee', formValues.monthlyFee, 'Monthly Fee', 'Monthly Fee', '100px')), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-9"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-3"
      }, /*#__PURE__*/React.createElement(DatePicker, {
        floatingLabelText: "Start Date",
        firstDayOfWeek: 0,
        textFieldStyle: {
          height: 72
        },
        hintText: "Start Date",
        value: formValues.contractStartsAt,
        onChange: this.handleDateChange
      }), /*#__PURE__*/React.createElement(SelectField, {
        floatingLabelText: "Number of Months",
        value: formValues.contractMonths,
        onChange: this.handleSelectChange
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1,
        primaryText: "Month to Month"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 2,
        primaryText: "2 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 3,
        primaryText: "3 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 4,
        primaryText: "4 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 5,
        primaryText: "5 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 6,
        primaryText: "6 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 7,
        primaryText: "7 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 8,
        primaryText: "8 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 9,
        primaryText: "9 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 10,
        primaryText: "10 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 11,
        primaryText: "11 Months"
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 12,
        primaryText: "12 Months"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-9"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          display: 'inline-block',
          paddingTop: 32,
          paddingBottom: 8
        }
      }, "Included Team Members: 1 @ $0/month")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingRight: 12
        }
      }, "Initial Team Members:"), this.renderInput('initialTeamMembers', formValues.initialTeamMembers, '0', 'Quantity', '55px'), /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "@"), /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "$"), this.renderInput('initialTeamMembersMonthlyPrice', formValues.initialTeamMembersMonthlyPrice, '0', 'Price', '55px'), /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "/month")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingRight: 12
        }
      }, "Additional Team Members:"), /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "$"), this.renderInput('additionalTeamMembersMonthlyPrice', formValues.additionalTeamMembersMonthlyPrice, '0', 'Price', '55px'), /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "/month")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          display: 'inline-block',
          paddingTop: 32,
          paddingBottom: 8
        }
      }, "Initial Admin Account: 1 @ $0/month")), !isAffiliateContract && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingRight: 12
        }
      }, "Initial ", isMultilocationContract ? 'Locations' : 'Clients', ":"), this.renderInput('initialClients', formValues.initialClients, '0', 'Quantity', '55px'), /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "@"), "$", this.renderInput('initialClientsMonthlyPrice', formValues.initialClientsMonthlyPrice, '0', 'Price', '55px'), /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "/month")), isMultilocationContract && /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingRight: 12
        }
      }, "Location management fee:"), /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "$"), this.renderInput('llManagedMonthlyFee', formValues.llManagedMonthlyFee, '0', 'Price', '55px'), /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "/month")), isAffiliateContract && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          marginTop: 32
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Package Manager"), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(ProductAccordion, {
        style: {
          flex: 1
        },
        emptyState: /*#__PURE__*/React.createElement("div", {
          style: {
            color: '#616161',
            padding: 8
          }
        }, "No packages yet. You need at least one product package to create an agreement."),
        products: this.props.products,
        handleAddProduct: this.props.addProduct,
        handleArchiveProduct: function handleArchiveProduct(id) {
          _this2.props.stateOnlyArchiveProduct(id);
        },
        handleSaveProduct: function handleSaveProduct(product) {
          _this2.props.stateOnlySaveProduct(product);
        }
      }))), !isMultilocationContract && !isAffiliateContract && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Client Management Fees"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingRight: 12
        }
      }, "Partner Managed Clients:"), /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "$"), this.renderInput('partnerManagedMonthlyFee', formValues.partnerManagedMonthlyFee, '0', 'Price', '55px'), /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "/month")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingRight: 12
        }
      }, "Likeable Local Managed Clients:"), /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "$"), this.renderInput('llManagedMonthlyFee', formValues.llManagedMonthlyFee, '0', 'Price', '55px'), /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "/month"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: styles.sectionHeader
      }, "Ad Placement Fees"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label,
        style: {
          paddingRight: 12
        }
      }, "Likeable Local keeps"), /*#__PURE__*/React.createElement(TextField, {
        hintText: '0',
        floatingLabelText: 'Percent',
        id: 'adsFeePercent',
        value: formValues.adsFeePercent,
        onChange: function onChange(e, val) {
          _this2.props.handleFormFieldChange('adsFeePercent', val);
        },
        style: {
          width: 55
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          paddingLeft: 12,
          paddingRight: 12
        }
      }, "% of ad spend.")), function () {
        var rawPercent = _this2.props.formValues.adsFeePercent;
        var adsFeePercent = parseFloat(rawPercent);

        if (rawPercent === null || rawPercent === undefined || isNaN(adsFeePercent)) {
          return /*#__PURE__*/React.createElement("p", {
            style: {
              color: 'red'
            }
          }, "You must enter a valid number for the Ad Placement Fee.");
        }

        if (adsFeePercent < 0 || adsFeePercent > 25) {
          return /*#__PURE__*/React.createElement("p", {
            style: {
              color: 'red'
            }
          }, "Ads Placement Fee must be at least 0% and no greater than 25%.");
        }

        return null;
      }()))), !this.props.sendingContract ? /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 36,
          marginBottom: 36
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(GrayButton, {
        style: {
          marginRight: 24
        },
        label: "Cancel",
        onClick: this.props.handleLeave
      }), /*#__PURE__*/React.createElement(SecondaryButton, {
        disabled: function () {
          if (isAffiliateContract) {
            return !_this2.props.products || _this2.props.products && _this2.props.products.length <= 0;
          }

          var adsFee = parseFloat(_this2.props.formValues.adsFeePercent);
          return isNaN(adsFee) || !isNaN(adsFee) && (adsFee < 0 || adsFee > 25);
        }(),
        primary: false,
        onClick: function onClick() {
          _this2.props.handleSubmit();
        },
        label: 'Submit'
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 36,
          marginBottom: 36,
          minHeight: 80
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          position: 'relative',
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))));
    }
  }]);

  return NewPartnerForm;
}(Component)) || _class);
export default reduxForm({
  form: 'asyncValidation',
  // a unique identifier for this form
  asyncValidate: asyncValidate,
  asyncChangeFields: ['email']
})(NewPartnerForm);